import React from "react";
import { useDispatch, useSelector } from "react-redux";
import SingleSelect from "../../../components/commonComponents/Selectors/SingleSelect";
import { updateStateData } from "../../../Store/actions";

const MarketingFilters = ({ redux_param_name, reduxKeywordToSaveValue, enabledFor }) => {
  const userStateData = useSelector((state) => state.userSelections);
  const dispatchAction = useDispatch();
  const [activitySelection, setActivitySelection] = React.useState({});
  const [dataLoaded, setDataLoaded] = React.useState(false);
  const activityOptions =
    typeof userStateData.activityOptions !== "undefined" && userStateData.activityOptions.length !== 0
      ? userStateData.activityOptions.sort()
      : [];

  // there's a new "Activity type" filter that is exactly same except that there's one hard coded option added to the list
  const dropdownOptions = typeof enabledFor !== "undefined" && enabledFor === "activity_type_dropdown" ? ["Retailer Promotion", ...activityOptions] : activityOptions

  React.useEffect(() => {
    if (dropdownOptions.length !== 0) {
      setActivitySelection({ value: dropdownOptions[0], label: dropdownOptions[0] });
      dispatchAction(
        updateStateData({
          [reduxKeywordToSaveValue]: {
            ...userStateData[reduxKeywordToSaveValue],
            [redux_param_name]: dropdownOptions[0],
          },
        })
      );
    }
    setTimeout(() => {
      setDataLoaded(true);
    }, 1000);

  }, []);

  return (
    <>
      {/* ------------ activity type --------------- */}
      {dataLoaded === true && (
        <SingleSelect
          enableFullWidth={true}
          label={"Activity Type"}
          selectionCheck={(option, value) => option.label === value.label}
          options={dropdownOptions.map((activityName) => {
            return { value: activityName, label: activityName };
          })}
          sortOptions={typeof enabledFor !== "undefined" && enabledFor === "activity_type_dropdown" ? false : true}
          defaultVal={activitySelection}
          onChangeCall={(selectedOption) => {
            let userChoices = selectedOption.value;
            setActivitySelection(selectedOption);
            dispatchAction(
              updateStateData({
                [reduxKeywordToSaveValue]: {
                  ...userStateData[reduxKeywordToSaveValue],
                  [redux_param_name]: userChoices,
                },
              })
            );
          }}
        />
      )}
    </>
  );
};

export default MarketingFilters;
